module.exports = __webpack_public_path__ + "static/media/ChevronIcon.8b108e3d.svg";